import React from "react";
import { config } from "../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
// import { useNavigate } from "react-router-dom";

function PopularDestinations({ onDestinationSelect }) {
  const destinations = [
    { country: "Australia", flag: "🇦🇺" },
    { country: "Canada", flag: "🇨🇦" },
    { country: "France", flag: "🇫🇷" },
    { country: "Hong Kong", flag: "🇭🇰" },
    { country: "India", flag: "🇮🇳" },
    { country: "Malaysia", flag: "🇲🇾" },
    { country: "New Zealand", flag: "🇳🇿" },
    { country: "UK", flag: "🇬🇧" },
    { country: "USA", flag: "🇺🇸" },
  ];

  const handleClick = (country) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    onDestinationSelect(country);
  };

  return (
    <div className="container mx-auto px-4 py-16">
      <div className="text-center mb-12">
        <div className="relative">
          <div className="absolute left-1/2 transform -translate-x-1/2 -top-20">
            <div className="relative">
              <div
                className={`w-16 h-16 bg-${config.primaryColor} rounded-full flex items-center justify-center mx-auto`}
              >
                <svg
                  className="w-8 h-8 text-white"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                  />
                </svg>
              </div>
              <div className="absolute -top-4 -right-8">
                <span className="flag text-2xl">🇺🇸</span>
              </div>
              <div className="absolute -top-8 -left-8">
                <span className="flag text-2xl">🇬🇧</span>
              </div>
              <div className="absolute -top-2 right-8">
                <span className="flag text-2xl">🇫🇷</span>
              </div>
              <div className="absolute -top-6 left-8">
                <span className="flag text-2xl">🇦🇺</span>
              </div>
            </div>
          </div>
        </div>
        <h2 className="text-3xl font-bold mt-8 mb-4">Popular destinations</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {destinations.map((destination) => (
          <button
            key={destination.country}
            onClick={() => handleClick(destination.country)}
            className="bg-gray-100 rounded-3xl p-6 flex items-center justify-between hover:shadow-md transition-shadow text-left w-full"
          >
            <div className="flex items-center gap-4">
              <span className="text-3xl">{destination.flag}</span>
              <span className="text-lg">Flights to {destination.country}</span>
            </div>
            <FontAwesomeIcon
              className="bg-white p-2 w-4 h-4 rounded-full"
              icon={faChevronRight}
            />
          </button>
        ))}
      </div>
    </div>
  );
}

export default PopularDestinations;
